import React from 'react'
import { useI18n } from '../../i18n'
import { fetchInformationSystems, type InformationSystemSummary } from '../../services/informationSystemsApi'

interface Props {
  value: string
  onChange: (systemId: string) => void
  organizationId?: string | null
  token?: string | null
}

export default function InformationSystemInventoryFilter({ value, onChange, organizationId, token }: Props) {
  const { t } = useI18n()
  const [systems, setSystems] = React.useState<InformationSystemSummary[]>([])

  React.useEffect(() => {
    if (!token) return
    fetchInformationSystems(token, organizationId)
      .then((data) => setSystems(Array.isArray(data) ? data : []))
      .catch(() => setSystems([]))
  }, [token, organizationId])

  if (systems.length === 0) return null

  return (
    <div className="flex flex-wrap items-center gap-2 mb-2">
      <label className="text-sm text-gray-600" htmlFor="is-inventory-filter">
        {t('assets.inventory.filterBySystem', 'Filter by information system')}
      </label>
      <select
        id="is-inventory-filter"
        className="border rounded px-2 py-1 text-sm min-w-[220px]"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">{t('assets.inventory.allSystems', 'All assets')}</option>
        {systems.map((s) => (
          <option key={s.id} value={s.id}>
            {s.name}
          </option>
        ))}
      </select>
    </div>
  )
}
